export default {
  description: 'User activated search',
  name: 'Activated search',
  params: [
    {
      description: 'The location where the user activated search',
      name: 'location',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the search was a quick search',
      name: 'isQuickSearch',
      required: true,
      type: 'boolean',
    },
  ],
};
